import React from 'react';

function mirror(o) {
  return o;
}

export default function mapSelf(children) {
  // return ReactFragment
  return React.Children.map(children, mirror);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-calendar/node_modules/rc-util/es/Children/mapSelf.js
// module id = 726
// module chunks = 0